import { ams } from './ams';
import { bergamos } from './bergamos';
import { demo } from './demo';
import { dhi } from './dhi';
import { hairscalp } from './hairscalp';
import { hrimn } from './hrimn';
import { kvcm } from './kvcm';
import { sbl } from './sbl';

const clients: { [key: string]: any } = {
  ams,
  bergamos,
  demo,
  dhi,
  hrimn,
  sbl,
  kvcm,
  hairscalp
};

const DEFAULT_CLIENT = 'demo';

// eslint-disable-next-line import/no-mutable-exports
let config: any = clients[process.env.CLIENT_NAME || DEFAULT_CLIENT];

// In dev or when CLIENT_NAME is set we explicitly skip trying external config
const checkExternal =
  process.env.NODE_ENV !== 'development' &&
  typeof process.env.APP_ENV !== 'undefined';

// XL TEAM: preserve legacy support for dev purposes by using a loophole with missing APP_ENV in the definitions
if (checkExternal) {
  try {
    // XL TEAM: Create support for static config for use on client servers, both for
    // Dynamic path avoids hard dependency during build when external config is absent
    const externalConfigPath = `${process.cwd()}/config/default`;
    // @ts-ignore - Dynamic require is intentional for external config loading
    // eslint-disable-next-line @typescript-eslint/no-var-requires, import/no-dynamic-require, global-require
    const externalConfig = require(externalConfigPath);
    config = externalConfig.config || externalConfig.default || externalConfig;
  } catch (error: any) {
    // XL TEAM: Preserve legacy support if server-side config is missing
    console.warn(
      'External config not found, using default client config:',
      error?.message ?? error
    );
    config = clients[process.env.CLIENT_NAME || DEFAULT_CLIENT];
  }
}

export default config;
